import { ArrowDownIcon, ArrowUpIcon } from '@heroicons/react/20/solid';
import type { LeaguesList } from '@library/types/leagues';
import { PLAYER_PLACEHOLDER_IMAGE_URL } from '@bo-constants/newWagers';
import type { PlayerPackProjection } from '@library/types/playerPacks/playerPacks';
import { useMemo } from 'react';

export const DrawerRow = ({
  label,
  value
}: {
  label: string;
  value: string | number;
}) => {
  return (
    <div className="flex flex-col gap-1">
      <div className="text-soClean-170 text-sm font-light">{label}</div>
      <div className="text-soClean-100 text-sm">{value}</div>
    </div>
  );
};

export const PickRow = ({
  pick,
  leaguesList
}: {
  pick: PlayerPackProjection;
  leaguesList: LeaguesList;
}) => {
  const {
    playerName,
    wagerType,
    projectionValue,
    statType,
    playerImageUrl,
    leagueId
  } = pick;

  const sport = useMemo(() => {
    return leaguesList.find((league) => league.id === leagueId);
  }, [leaguesList, leagueId]);

  return (
    <div className="flex w-full justify-between px-3 py-2">
      <div className="flex items-center gap-2">
        <img
          src={playerImageUrl || PLAYER_PLACEHOLDER_IMAGE_URL}
          alt="Player"
          className="bg-soFresh-120 size-9 rounded-full"
        />
        <img
          src={sport?.imageUrl}
          alt={sport?.icon}
          className="relative right-4 top-3 size-3"
        />
        <div className="text-soClean-100 flex items-center text-lg font-semibold">
          {playerName}
        </div>
      </div>

      <div className="text-soClean-100 flex flex-col">
        <div className="flex items-center gap-1">
          {wagerType === 'more' && (
            <ArrowUpIcon className="text-soClean-100 size-4" />
          )}
          {wagerType === 'less' && (
            <ArrowDownIcon className="text-soClean-100 size-4" />
          )}
          <span className="text-lg font-semibold">{projectionValue}</span>
        </div>
        <span className="text-soClean-170 flex justify-end text-xs font-light">
          {statType}
        </span>
      </div>
    </div>
  );
};
